import script from "./a-plan-manual.vue?vue&type=script&lang=tsx&setup=true"
export * from "./a-plan-manual.vue?vue&type=script&lang=tsx&setup=true"

import "./a-plan-manual.vue?vue&type=style&index=0&id=bce59872&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bce59872"]])

export default __exports__